import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { APPOINTMENT_ROUTES } from '../consts';
import { SessionService } from '../pages/appointment/authenticate';
import { EntryPrefillService } from './entry-prefill.service';
import { HostEvent, HostEventService } from './host-event.service';

@Injectable({ providedIn: 'root' })
export class BackToEmailService {
  private readonly router: Router = inject(Router);
  private readonly sessionService: SessionService = inject(SessionService);
  private readonly entryPrefill: EntryPrefillService = inject(EntryPrefillService);
  private readonly hostEvents: HostEventService = inject(HostEventService);

  public leave(email: string | null, from: HostEvent['from']): void {
    this.entryPrefill.consumePlate();
    this.entryPrefill.capture(null, email);
    this.hostEvents.emit({ name: 'back-to-email', from });
    this.sessionService.logout().subscribe({
      complete: (): void => {
        this.router.navigate([APPOINTMENT_ROUTES.REDIRECT_URL], { replaceUrl: true });
      },
    });
  }
}
